export default __webpack_public_path__ + "static/media/kyourei.78666e73.png";